export default "/assets/images/mama-room1.713104a82988aa7f.png";